import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

import config from '@dabea/common/lib/config'

const app = initializeApp(config.firebase)

// Initialize Analytics and get a reference to the service
export const analytics = getAnalytics(app)
